import { OrderItemSerializable } from './order-item-serializable';

export class LegacyAdjustmentOrderItemSerializable extends OrderItemSerializable {
  membershipPeriodId: number;
  adjustedAmount: number;
  isFullRefund: boolean;
}
